import { connect } from 'react-redux'

import CountdownPickupTimer, { IStateProps, IDispatchProps, IOwnProps } from './CountdownPickupTimer'
import { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    vehicle: state.Dashboard.vehicles[0],
  }
}

function mapDispatchToProps(): IDispatchProps {
  return {}
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(CountdownPickupTimer)
